import { css } from "@emotion/react";
import { Spacing } from "@snapchat/snap-design-system";

export const exampleTopPadding = css`
    padding-top: ${Spacing.LG}px;
`;

export const codeTopPadding = css`
    margin-top: ${Spacing["2XL"]}px;
`;

export const routeDetailsTopPadding = css`
    padding: 2rem 1rem;

    @media (max-width: 400px) {
        padding: 2rem 0;
    }
`;
